import { render, staticRenderFns } from "./InboxNewLetter.vue?vue&type=template&id=43535a9c"
import script from "./InboxNewLetter.vue?vue&type=script&lang=js"
export * from "./InboxNewLetter.vue?vue&type=script&lang=js"
import style0 from "./InboxNewLetter.vue?vue&type=style&index=0&id=43535a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports